<template>
  <div id="app">
    <BrowserInfo v-show="showBrowserTip" @showTip="showTip" @ignore="ignore" />
    <div ref="removeRef"></div>
    <router-view />
  </div>
</template>
<script>
export default {
  name: "",
  data() {
    return {
      throttleInnerFunction: null
    };
  },
  computed: {
    showBrowserTip() {
      // console.log(this.$store.state.showBrowserTip,"this.$store.state.showBrowserTip--");
      return this.$store.state.showBrowserTip;
    },
  },
  created() {
    window.apiHost = window.location.hostname;
  },
  mounted() {
    // 滚动时移除下拉框等元素
    window.addEventListener(
      "scroll",
      this.throttle(this.scrollEvent, 100),
      true
    );
  },
  destroyed() {
    window.removeEventListener("scroll", this.throttle, true);
  },
  methods: {
    // throttle(fn, delay) {
    //   let runFlag = false;
    //   return function () {
    //     // 判断之前的调用是否完成
    //     if (runFlag) {
    //       return false;
    //     }
    //     runFlag = true;
    //     setTimeout(() => {
    //       fn();
    //       runFlag = false;
    //     }, delay);
    //   };
    // },
    throttle(fn, delay) {
      let lock = false;
      let timer = null;
      this.throttleInnerFunction = function() {
        if(timer) {
          clearTimeout(timer);
          timer = setTimeout(() => {
            lock = false;
            timer = null;
          }, delay)
          return;
        }
        if(lock){
          return
        }
        fn();
        lock = true;
        timer = setTimeout(() => {
          lock = false;
          timer = null;
        }, delay);
      }
      return this.throttleInnerFunction;
    },
    poptipHidden(component) {
      if(component.$options.name == "Poptip") {
        component.visible && component.handleClose();
      } else {
        component.$children.forEach(item => {
          this.poptipHidden(item);
        })
      }
    },
    scrollEvent() {
      // this.$refs.removeRef.click();
      this.poptipHidden(this)
    },
    showTip(flag) {
      if (
        sessionStorage.AGENT_TIP &&
        JSON.parse(sessionStorage.AGENT_TIP) == false
      ) {
        return;
      }
      this.$store.commit("setBrowserTip", flag);
    },
    ignore() {
      this.$store.commit("setBrowserTip", false);
    },
  },
};
</script>
<style lang="scss">
@import "./assets/scss/common.scss";
@import "./assets/scss/reset.scss";
#app {
  width: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // min-width: 1366px;
}
// label标签的样式
#fontsize .ivu-form-item-label {
  font-size: 12px;
  color: #67799c;
  line-height: 14px;
  width: 1366px;
}
</style>
